<div class="list-page">
  <app-asiakas-otsikko otsikko="Aineiston lähetys" paluuUrl="/asiakkaat" [asiakas]="asiakasObservable | async"></app-asiakas-otsikko>

  @if (kirjanpitajaOnDevaajaObservable | async) {
    <div style="padding-bottom: 20px">
      <h3 style="margin: 0">Urit</h3>
      <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
        Lataukset (Lemonaid): <a [href]="latauksetEncodedUriObservable | async" target="_BLANK">{{ latauksetUriObservable | async }}</a>
      </div>
    </div>
  }

  <div style="display: flex; flex-flow: row wrap">
    <form>
      <div style="display: flex; justify-content: space-between; flex-flow: row wrap; width: 275px; margin-right: 40px">
        <mat-form-field style="max-width: 125px">
          <mat-label>Alkaa</mat-label>
          <input type="text" [max]="alkaaMaxDate()" [matDatepicker]="alkaaPicker" [formField]="lomake.alkaa" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="alkaaPicker"></mat-datepicker-toggle>
          <mat-datepicker #alkaaPicker></mat-datepicker>
          @if (onkoVirhe(lomake.alkaa, 'required') && (lomake.alkaa().dirty() || lomake.alkaa().touched())) {
            <mat-error>Alkamiskuukausi puuttuu</mat-error>
          }
          @if (onkoVirhe(lomake.alkaa, 'matDatepickerMax') && (lomake.alkaa().dirty() || lomake.alkaa().touched())) {
            <mat-error>Ei ole loppumiskuukautta ennen</mat-error>
          }
        </mat-form-field>
        <mat-form-field style="max-width: 125px">
          <mat-label>Loppuu</mat-label>
          <input type="text" [min]="loppuuMinDate()" [matDatepicker]="loppuuPicker" [formField]="lomake.loppuu" matInput data-lpignore="true" />
          <mat-datepicker-toggle matSuffix [for]="loppuuPicker"></mat-datepicker-toggle>
          <mat-datepicker #loppuuPicker></mat-datepicker>
          @if (onkoVirhe(lomake.loppuu, 'required') && (lomake.loppuu().dirty() || lomake.loppuu().touched())) {
            <mat-error>Loppumiskuukausi puuttuu</mat-error>
          }
          @if (onkoVirhe(lomake.loppuu, 'matDatepickerMin') && (lomake.loppuu().dirty() || lomake.loppuu().touched())) {
            <mat-error>Ei ole alkamiskuukauden jälkeen</mat-error>
          }
        </mat-form-field>
      </div>
      <mat-form-field style="width: 275px">
        <mat-label>Kieli</mat-label>
        <mat-select [formField]="lomake.kieli">
          @for (valittavaKieli of valittavatKielet; track valittavaKieli) {
            <mat-option [value]="valittavaKieli.tunniste">
              {{ valittavaKieli.nimi }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>

    <div>
      <div class="light-blue-text" style="font-size: 20px; margin-bottom: 4px; line-height: 22px; margin-top: -10px">Tilikaudet</div>
      @if (asiakasObservable | async; as asiakas) {
        @for (tilikausi of asiakas.tilikaudet; track tilikausi) {
          <div style="display: flex; align-items: center">
            {{ tilikausi.alkaa | lokaalipvm | async }} - {{ tilikausi.loppuu | lokaalipvm | async }}
            <app-button (click)="valitseTilikaudenAikavali(tilikausi)" actionId="Valitse tilikauden aikaväli" [actionContext]="[tilikausi.alkaa, '-', tilikausi.loppuu]"> Valitse aikaväli </app-button>
          </div>
        }
      }
    </div>
  </div>

  <app-primary-button (click)="luoAineisto()" actionId="Luo aineisto" [actionContext]="$any(lomake().value())" styles="margin: 2em 0;"> Luo aineisto </app-primary-button>

  <div>
    <h2 style="font-size: 22px; line-height: 40px; padding: 15px 0 5px" class="light-blue-text">Aikaisemmin luodut aineistot</h2>
    @if (ladattavatAineistotObservable | async; as ladattavatAineistot) {
      <table style="border-spacing: 0">
        <thead>
          <tr>
            <th>Luotu</th>
            <th>Tila</th>
            <th>Aikaväli</th>
            <th>Lataa nyt</th>
            <th>Anna latauslinkki</th>
            <th>Lähetä</th>
            <th>Lähetetty</th>
            <th>Kuitattu</th>
            @if (kirjanpitajaOnDevaajaObservable | async) {
              <th>URI</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (ladattavaAineisto of ladattavatAineistot; track ladattavaAineisto) {
            <tr>
              <td [title]="ladattavaAineisto.kn">
                {{ ladattavaAineisto.c | ltimestamptime | async }}
              </td>
              <td>
                @if (ladattavaAineisto.b !== 'o' && ladattavaAineisto.b !== 'v') {
                  <div style="width: 130px">{{ ladattavaAineisto.b === 't' ? 'Tarkistetaan' : 'Luodaan' }}<mat-progress-spinner diameter="20" style="display: inline-block; margin-left: 10px; vertical-align: middle" mode="indeterminate"></mat-progress-spinner></div>
                }
                @if (ladattavaAineisto.b === 'o') {
                  <div>Valmis</div>
                }
                @if (ladattavaAineisto.b === 'v') {
                  <div>Virheellinen</div>
                }
              </td>
              <td>{{ ladattavaAineisto.s | lnumberpvm | async }} - {{ ladattavaAineisto.e | lnumberpvm | async }}</td>
              <td style="text-align: center">
                @if (ladattavaAineisto.b === 'o') {
                  <app-button (click)="lataaNyt(ladattavaAineisto)" actionId="Lataa luotu kirjanpidon aineisto koneelle" [actionContext]="[ladattavaAineisto.l]"> Lataa </app-button>
                }
              </td>
              <td style="text-align: center">
                @if (ladattavaAineisto.b === 'o') {
                  <app-button (click)="luoLatauslinkki(ladattavaAineisto)" actionId="Aineiston lataus: aloita latauslinkin luonti" [actionContext]="[ladattavaAineisto.l]"> Latauslinkki </app-button>
                }
              </td>
              <td style="text-align: center">
                @if (ladattavaAineisto.b === 'o') {
                  <app-button (click)="lahetaAsiakkaalle(ladattavaAineisto)" actionId="Aineiston lataus: Lähetä aineisto asiakkaalle" [actionContext]="[ladattavaAineisto.l]">{{ ladattavaAineisto.lahetettyAsiakkaalle ? 'Lähetä asiakkaalle uudelleen' : 'Lähetä asiakkaalle' }}</app-button>
                }
              </td>
              <td style="text-align: center">
                @if (ladattavaAineisto.lahetettyAsiakkaalle) {
                  <div>Aineisto lähetetty asiakkaalle {{ ladattavaAineisto.lahetettyAsiakkaalle | ltimestamptime | async }}</div>
                }
              </td>
              <td style="text-align: center">
                @if (ladattavaAineisto.kuitattuNoudetuksi) {
                  <div>Aineisto kuitattu noudetuksi {{ ladattavaAineisto.kuitattuNoudetuksi | ltimestamptime | async }} {{ ladattavaAineisto.kuittaajanTiedot ? '(' + ladattavaAineisto.kuittaajanTiedot.etunimi + ' ' + ladattavaAineisto.kuittaajanTiedot.sukunimi + ')' : '' }}</div>
                }
              </td>
              @if (kirjanpitajaOnDevaajaObservable | async) {
                <td>
                  <a [href]="(latauksetEncodedUriObservable | async) + '/' + ladattavaAineisto.l" target="_BLANK">{{ ladattavaAineisto.l }}</a>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </div>
</div>
